<template>
  <div class="business">
    <menuBox :step="2"></menuBox>
    <div class="top-box">
      <div class="top-title">Sejarah Perkembangan</div>
      <div class="top-content">
        PT JASINDO CITRA MAJU / Sejarah Perkembangan
      </div>
    </div>
    <div class="business-box">
      <div class="business-img-text">
        <img src="../assets/mission-1.png" />
        <div class="text text-l">
          <div class="title">Sejarah perkembangan kita</div>
          <div class="l-title">Sejak didirikan, PT Jasindo Citra Maju telah berkomitmen untuk menjadi penyedia layanan kesejahteraan sosial dan kesehatan terkemuka di Indonesia.</div>
          <p>
            Perusahaan ini awalnya berfokus pada proyek komunitas berskala kecil dan secara bertahap berkembang ke sektor kesejahteraan dan kesehatan yang lebih luas. Seiring berjalannya waktu, kami telah mencapai hasil yang luar biasa dalam bidang keamanan kerja dan kesehatan masyarakat. Melalui inovasi dan perluasan layanan yang berkelanjutan, kami telah berhasil meningkatkan kualitas hidup dan kesejahteraan ekonomi masyarakat, sehingga mendapatkan pengakuan luas dari masyarakat dan industri.
          </p>
        </div>
      </div>
    </div>
    <div class="history-box">
      <div class="title">Cerita Kita</div>
      <div class="l-title">Temukan cara yang lebih baik untuk berkembang</div>
      <div class="history-flex">
        <div class="history-list">
          <div class="item">
            <div class="img-bg">
              <img src="../assets/history-icon-1.png" alt="" />
            </div>
            <div class="content">
              <div class="item-title">Fase start-up: meletakkan fondasi</div>
              <p>
                Awalnya berfokus pada proyek kesejahteraan masyarakat skala kecil, kami secara bertahap membangun merek perusahaan dan meletakkan dasar yang kuat untuk pengembangan di masa depan.
              </p>
            </div>
          </div>
          <div class="item">
            <div class="img-bg">
              <img src="../assets/history-icon-2.png" alt="" />
            </div>
            <div class="content">
              <div class="item-title">Perluasan cakupan layanan</div>
              <p>
                Bisnis ini secara bertahap diperluas hingga mencakup layanan kesejahteraan sosial dan kesehatan yang komprehensif, termasuk bantuan khusus untuk kelompok tertentu.
              </p>
            </div>
          </div>
          <div class="item">
            <div class="img-bg">
              <img src="../assets/history-icon-3.png" alt="" />
            </div>
            <div class="content">
              <div class="item-title">Implementasi proyek-proyek penting</div>
              <p>
                Keberhasilan pelaksanaan sejumlah proyek penting, seperti pelatihan ketenagakerjaan bagi penyandang disabilitas, telah meningkatkan kualitas hidup mereka secara signifikan.
              </p>
            </div>
          </div>
        </div>
        <div class="img-list">
          <img src="../assets/history-1.png" alt="" />
          <img src="../assets/history-2.png" alt="" />
        </div>
        <div class="history-list">
          <div class="item">
            <div class="img-bg">
              <img src="../assets/history-icon-4.png" alt="" />
            </div>
            <div class="content">
              <div class="item-title">Inovasi teknologi mendorong pembangunan</div>
              <p>
                Penggunaan teknologi dan metode inovatif telah secara efektif meningkatkan kualitas layanan dan dampak proyek yang berkelanjutan.
              </p>
            </div>
          </div>
          <div class="item">
            <div class="img-bg">
              <img src="../assets/history-icon-5.png" alt="" />
            </div>
            <div class="content">
              <div class="item-title">Membangun jaringan kerja sama masyarakat</div>
              <p>
                Membangun kemitraan dengan bisnis lokal dan LSM untuk bekerja sama dalam kesejahteraan dan kesehatan masyarakat.
              </p>
            </div>
          </div>
          <div class="item">
            <div class="img-bg">
              <img src="../assets/history-icon-6.png" alt="" />
            </div>
            <div class="content">
              <div class="item-title">Diakui dalam industri</div>
              <p>
                Dengan kontribusi sosial dan inovasi layanannya yang luar biasa, perusahaan ini telah menerima pengakuan luas dan berbagai penghargaan baik di dalam maupun di luar industri.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="statistics-box">
      <div class="title">prestasi kita</div>
      <div class="l-title">Bekerja lebih keras untuk menciptakan masa depan yang lebih baik</div>
      <div class="statistics-list">
        <div class="item">
          <div class="rate">
            1k+
          </div>
          <p>sukarelawan</p>
        </div>
        <div class="item">
          <div class="rate">
            5k+
          </div>
          <p>orang terbantu</p>
        </div>
        <div class="item">
          <div class="rate">
            19%
          </div>
          <p>cakupan komunitas</p>
        </div>
        <div class="item">
          <div class="rate">
            8+
          </div>
          <p>proyek</p>
        </div>
        <div class="item">
          <div class="rate">
            100%
          </div>
          <p>Tingkat bantuan</p>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.top-box {
  height: 60px;
  background: #ce3723;
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-title {
    font-size: 24px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #ffffff;
    line-height: 29px;
  }
  .top-content {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
.about-title {
  background-image: url(../assets/about-1.png);
  width: 100%;
  height: 320px;
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;
  .title {
    font-size: 64px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 100px;
  }
  p {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}

.business-text {
  padding: 80px 360px 120px 360px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;

  p {
    text-indent: 2em;
    margin-top: 28px;
  }
}

.business-box {
  padding: 0px 360px;
  background-color: #f2f2f2;
  overflow: hidden;
  padding-top: 80px;
  .business-img-text {
    display: flex;
    justify-content: space-between;
    margin-bottom: 80px;

    img {
      width: 564px;
    }

    .text {
      width: 500px;

      .title {
        font-size: 24px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #1e1e1e;
        line-height: 29px;
        margin-top: 70px;
      }
      .l-title {
        font-size: 14px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        line-height: 16px;
        margin-top: 16px;
      }
      p {
        font-size: 12px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        line-height: 14px;
        margin-top: 48px;
      }
    }
    .text-l {
      margin-left: 47px;
    }
    .text-r {
      margin-right: 47px;
    }
  }
}
.history-box {
  padding: 0 360px;
  height: 800px;
  background-color: #fff;
  .title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
    text-align: center;
    margin-top: 80px;
  }
  .l-title {
    font-size: 16px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #ce3723;
    line-height: 19px;
    text-align: center;
    margin-top: 12px;
  }
  .history-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;

    .img-list {
      width: 350px;
      img:nth-child(1) {
        margin-bottom: 16px;
      }
      img {
        width: 350px;
      }
    }
    .history-list {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 550px;
      .item {
        display: flex;
        justify-content: flex-start;
        .img-bg {
          border: 4px solid #ddd;
          width: 76px;
          height: 76px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 24px;
            height: 24px;
          }
        }
        .content {
          max-width: 250px;
          margin-left: 30px;
          .item-title {
            font-size: 16px;
            font-family: Inter, Inter;
            font-weight: normal;
            color: #1e1e1e;
            line-height: 19px;
          }
          p {
            font-size: 12px;
            font-family: Inter, Inter;
            font-weight: 400;
            color: #959595;
            margin-top: 16px;
            line-height: 14px;
          }
        }
      }
    }
  }
}
.statistics-box {
  padding: 0 360px;
  height: 520px;
  overflow: hidden;
  background: #f2f2f2;
  .title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
    text-align: center;
    margin-top: 80px;
  }
  .l-title {
    font-size: 16px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #959595;
    line-height: 19px;
    text-align: center;
    margin-top: 12px;
  }
  .statistics-list {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 50px;
    .item:nth-child(2) .rate{
      height: 125px;
    }
    .item:nth-child(3) .rate{
      height: 177px;
    }
    .item:nth-child(4) .rate{
      height: 141px;
    }
    .item:nth-child(5) .rate{
      height: 205px;
    }
    .item {
      .rate {
        width: 170px;
        height: 180px;
        padding-left: 16px;
        padding-top: 16px;
        background: #ce3723;
        font-size: 20px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #ffffff;
        line-height: 24px;
      }
      p {
        font-size: 16px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #1e1e1e;
        line-height: 19px;
        margin-top: 16px;
      }
    }
  }
}
</style>
